import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CockpitKontrolleM1} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {
  Koeffiziente,
  ModellVariablenKoefficienteM1
} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';
import {ModellvariantenKoeffizienteService} from './modellvarianten-koeffiziente.service';

@Component({
  selector: 'app-modellvarianten-koeffiziente-table',
  templateUrl: './modellvarianten-koeffiziente-table.component.html',
  styleUrl: './modellvarianten-koeffiziente-table.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModellvariantenKoeffizienteComponent implements OnChanges {
  @Input() data: Koeffiziente;

  cockpitKontrolle: CockpitKontrolleM1;
  koefficiente: ModellVariablenKoefficienteM1;

  constructor(
    private readonly koeffizienteService: ModellvariantenKoeffizienteService,
    protected readonly translate: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.koefficiente =
        this.koeffizienteService.getPreparateKoefficienteM1data(
          changes.data.currentValue
        );
    }
  }
}
